import React from 'react';
import { SETTINGS } from 'modules/emergencies/constants';
import AvatarsContainer from 'modules/emergencies/components/ui/avatar/avatarsContainer';
import BodyColumn from 'modules/emergencies/components/ui/columns/bodyColumn';
import styled, { css } from 'styled-components';
import RegularText from 'modules/emergencies/components/ui/texts/RegularText';

const StyledBodyColumn = styled(BodyColumn)`
  padding: 16px;
  background-color: var(--grey100);
  ${({ hasMessage }) =>
    !hasMessage &&
    css`
      background-color: transparent;
    `}
`;

const StyledAvatarsContainer = styled(AvatarsContainer)`
  height: 100%;
  width: 100%;
`;

export const InternalCommentMessageColumn = ({ ticket }) => {
  const message = ticket?.comments?.length > 0 ? ticket?.comments[0]?.message : null;
  return (
    <StyledBodyColumn
      hasMessage={!!message}
      width={SETTINGS.TICKETS_TABLE_COLUMN_SIZES_IN_PX.INTERNAL_COMMENT_MESSAGE}
    >
      <StyledAvatarsContainer>
        <RegularText>{message}</RegularText>
      </StyledAvatarsContainer>
    </StyledBodyColumn>
  );
};
